import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const translations = {
  fi: {
    // Navigation
    nav: {
      story: 'Tarinamme',
      menu: 'Ruokalista',
      contact: 'Yhteystiedot'
    },
    // Hero
    hero: {
      tagline: 'Aitoja makuja ja tunnelmaa Pornaisissa',
      orderButton: 'Tilaa Ruokaa',
      est: 'Est. 2024'
    },
    // About
    about: {
      since: 'Since 2024',
      title: 'Tarinamme',
      text1: 'Tarjoamme herkullisia ruokia korkealaatuisista raaka-aineista, jotka valmistetaan perinteisiä reseptejä kunnioittaen. Sijaitsemme Pornaisissa, ja tavoitteemme on tarjota asiakkaillemme unohtumattomia makuelämyksiä sekä lämmintä palvelua.',
      text2: 'Tule nauttimaan viihtyisästä ilmapiiristä ja monipuolisesta ruokalistastamme. Tutustu ruokalistaan ja tilaa jo tänään!',
      dishes: 'Annoksia',
      quality: 'Laadukasta'
    },
    // Menu
    menu: {
      title: 'Ruokalistamme',
      subtitle: 'Tutustu laajaan valikoimaamme',
      pizzas: 'Pizzat',
      kebabs: 'Kebabit',
      grills: 'Grillit',
      salads: 'Salaatit',
      burgers: 'Burgerit',
      desserts: 'Jälkiruoat',
      comingSoon: 'valikoimamme päivitetään pian...'
    },
    // Contact
    contact: {
      title: 'Yhteystiedot',
      address: 'Osoite',
      phone: 'Puhelin',
      email: 'Sähköposti',
      hours: 'Aukioloajat',
      location: 'Sijaintimme',
      days: {
        monThu: 'Ma-To',
        fri: 'Pe',
        sat: 'La',
        sun: 'Su'
      }
    },
    // Footer
    footer: {
      tagline: 'Aitoja makuja Pornaisissa',
      contactInfo: 'Yhteystiedot',
      companyInfo: 'Yritystiedot',
      rights: 'Kaikki oikeudet pidätetään.'
    },
    // Pizza items
    pizzaItems: {
      margarita: { name: 'Margarita', desc: 'Juusto' },
      bolognese: { name: 'Bolognese', desc: 'Jauheliha' },
      hawaii: { name: 'Hawaii', desc: 'Kinkku, ananas' },
      julia: { name: 'Julia', desc: 'Kinkku, ananas, aurajuusto, katkarapu' },
      romeo: { name: 'Romeo', desc: 'Salami, katkarapu, ananas, aurajuusto' },
      frutti: { name: 'Frutti di mare', desc: 'Tonnikala, katkarapu, simpukka, sitruuna' },
      dillinger: { name: 'Dillinger', desc: 'Jauheliha, kinkku, salami, sipuli' },
      king: { name: 'King Pizza', desc: 'Kebab, salami, sipuli, pekoni' },
      vegetarian: { name: 'Vegetarian', desc: 'Paprika, oliivi, sipuli, paholaisen hillo, rucola' },
      kebabPizza: { name: 'Kebab Pizza', desc: 'Kebabliha, sipuli, turkinpippuri, kirsikkatomaatti' },
      chickenBBQ: { name: 'Chicken BBQ', desc: 'BBQ-kastike, broileri, sipuli, pekoni, mozzarella, juusto' },
      chickenHawaii: { name: 'Chicken Hawaii', desc: 'Kana, ananas, aurajuusto' },
      meatLover: { name: 'Lihaherkku', desc: 'Salami, kinkku, pekoni, jauheliha, kebab' },
      bossSpecial: { name: 'Boss Special', desc: 'Kebabliha, kana, kirsikkatomaatti, jalopeno, curry-kastike' },
      smetana: { name: 'Smetana', desc: 'Kebabliha, sipuli, jalopeno, fetajuusto, kirsikkatomaatti, smetana, valkosipuli' },
      mexicana: { name: 'Mexicana', desc: 'Pepperoni, jalopeno, mozzarella, ananas' },
      operaSpecial: { name: 'Opera Special', desc: 'Kinkku, salami, pekoni, kananmuna, smetana, valkosipuli' },
      calzone: { name: 'Calzone', desc: 'Sipuli, chili, kebabliha, kirsikkatomaatti' }
    }
  },
  en: {
    // Navigation
    nav: {
      story: 'Our Story',
      menu: 'Menu',
      contact: 'Contact'
    },
    // Hero
    hero: {
      tagline: 'Authentic flavors and atmosphere in Pornainen',
      orderButton: 'Order Food',
      est: 'Est. 2024'
    },
    // About
    about: {
      since: 'Since 2024',
      title: 'Our Story',
      text1: 'We offer delicious food made from high-quality ingredients, prepared with respect for traditional recipes. Located in Pornainen, our goal is to provide our customers with unforgettable taste experiences and warm service.',
      text2: 'Come enjoy a cozy atmosphere and our diverse menu. Check out our menu and order today!',
      dishes: 'Dishes',
      quality: 'Quality'
    },
    // Menu
    menu: {
      title: 'Our Menu',
      subtitle: 'Explore our wide selection',
      pizzas: 'Pizzas',
      kebabs: 'Kebabs',
      grills: 'Grills',
      salads: 'Salads',
      burgers: 'Burgers',
      desserts: 'Desserts',
      comingSoon: 'selection will be updated soon...'
    },
    // Contact
    contact: {
      title: 'Contact Information',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      hours: 'Opening Hours',
      location: 'Our Location',
      days: {
        monThu: 'Mon-Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun'
      }
    },
    // Footer
    footer: {
      tagline: 'Authentic flavors in Pornainen',
      contactInfo: 'Contact Information',
      companyInfo: 'Company Information',
      rights: 'All rights reserved.'
    },
    // Pizza items
    pizzaItems: {
      margarita: { name: 'Margarita', desc: 'Cheese' },
      bolognese: { name: 'Bolognese', desc: 'Ground beef' },
      hawaii: { name: 'Hawaii', desc: 'Ham, pineapple' },
      julia: { name: 'Julia', desc: 'Ham, pineapple, blue cheese, shrimp' },
      romeo: { name: 'Romeo', desc: 'Salami, shrimp, pineapple, blue cheese' },
      frutti: { name: 'Frutti di mare', desc: 'Tuna, shrimp, mussel, lemon' },
      dillinger: { name: 'Dillinger', desc: 'Ground beef, ham, salami, onion' },
      king: { name: 'King Pizza', desc: 'Kebab, salami, onion, bacon' },
      vegetarian: { name: 'Vegetarian', desc: 'Pepper, olive, onion, chili jam, arugula' },
      kebabPizza: { name: 'Kebab Pizza', desc: 'Kebab meat, onion, turkish pepper, cherry tomato' },
      chickenBBQ: { name: 'Chicken BBQ', desc: 'BBQ sauce, chicken, onion, bacon, mozzarella, cheese' },
      chickenHawaii: { name: 'Chicken Hawaii', desc: 'Chicken, pineapple, blue cheese' },
      meatLover: { name: 'Meat Lover', desc: 'Salami, ham, bacon, ground beef, kebab' },
      bossSpecial: { name: 'Boss Special', desc: 'Kebab meat, chicken, cherry tomato, jalapeno, curry sauce' },
      smetana: { name: 'Smetana', desc: 'Kebab meat, onion, jalapeno, feta cheese, cherry tomato, sour cream, garlic' },
      mexicana: { name: 'Mexicana', desc: 'Pepperoni, jalapeno, mozzarella, pineapple' },
      operaSpecial: { name: 'Opera Special', desc: 'Ham, salami, bacon, egg, sour cream, garlic' },
      calzone: { name: 'Calzone', desc: 'Onion, chili, kebab meat, cherry tomato' }
    }
  },
  sv: {
    // Navigation
    nav: {
      story: 'Vår Berättelse',
      menu: 'Meny',
      contact: 'Kontakt'
    },
    // Hero
    hero: {
      tagline: 'Äkta smaker och atmosfär i Pornainen',
      orderButton: 'Beställ Mat',
      est: 'Est. 2024'
    },
    // About
    about: {
      since: 'Sedan 2024',
      title: 'Vår Berättelse',
      text1: 'Vi erbjuder utsökt mat gjord av högkvalitativa ingredienser, tillagad med respekt för traditionella recept. Belägna i Pornainen är vårt mål att ge våra kunder oförglömliga smakupplevelser och varm service.',
      text2: 'Kom och njut av en mysig atmosfär och vår varierade meny. Kolla in vår meny och beställ idag!',
      dishes: 'Rätter',
      quality: 'Kvalitet'
    },
    // Menu
    menu: {
      title: 'Vår Meny',
      subtitle: 'Utforska vårt breda utbud',
      pizzas: 'Pizzor',
      kebabs: 'Kebaber',
      grills: 'Grillar',
      salads: 'Sallader',
      burgers: 'Hamburgare',
      desserts: 'Desserter',
      comingSoon: 'urval kommer att uppdateras snart...'
    },
    // Contact
    contact: {
      title: 'Kontaktinformation',
      address: 'Adress',
      phone: 'Telefon',
      email: 'E-post',
      hours: 'Öppettider',
      location: 'Vår Plats',
      days: {
        monThu: 'Mån-Tor',
        fri: 'Fre',
        sat: 'Lör',
        sun: 'Sön'
      }
    },
    // Footer
    footer: {
      tagline: 'Äkta smaker i Pornainen',
      contactInfo: 'Kontaktinformation',
      companyInfo: 'Företagsinformation',
      rights: 'Alla rättigheter förbehållna.'
    },
    // Pizza items
    pizzaItems: {
      margarita: { name: 'Margarita', desc: 'Ost' },
      bolognese: { name: 'Bolognese', desc: 'Köttfärs' },
      hawaii: { name: 'Hawaii', desc: 'Skinka, ananas' },
      julia: { name: 'Julia', desc: 'Skinka, ananas, ädelost, räkor' },
      romeo: { name: 'Romeo', desc: 'Salami, räkor, ananas, ädelost' },
      frutti: { name: 'Frutti di mare', desc: 'Tonfisk, räkor, mussla, citron' },
      dillinger: { name: 'Dillinger', desc: 'Köttfärs, skinka, salami, lök' },
      king: { name: 'King Pizza', desc: 'Kebab, salami, lök, bacon' },
      vegetarian: { name: 'Vegetarisk', desc: 'Paprika, oliv, lök, chilisylt, ruccola' },
      kebabPizza: { name: 'Kebab Pizza', desc: 'Kebabkött, lök, turkisk peppar, körsbärstomat' },
      chickenBBQ: { name: 'Chicken BBQ', desc: 'BBQ-sås, kyckling, lök, bacon, mozzarella, ost' },
      chickenHawaii: { name: 'Chicken Hawaii', desc: 'Kyckling, ananas, ädelost' },
      meatLover: { name: 'Köttälskare', desc: 'Salami, skinka, bacon, köttfärs, kebab' },
      bossSpecial: { name: 'Boss Special', desc: 'Kebabkött, kyckling, körsbärstomat, jalapeno, currysås' },
      smetana: { name: 'Smetana', desc: 'Kebabkött, lök, jalapeno, fetaost, körsbärstomat, gräddfil, vitlök' },
      mexicana: { name: 'Mexicana', desc: 'Pepperoni, jalapeno, mozzarella, ananas' },
      operaSpecial: { name: 'Opera Special', desc: 'Skinka, salami, bacon, ägg, gräddfil, vitlök' },
      calzone: { name: 'Calzone', desc: 'Lök, chili, kebabkött, körsbärstomat' }
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('fi');

  const t = translations[language];

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('preferredLanguage', lang);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
